import WinnersActionTypes from './types';

export const fetchWinnersStart = searchQuery => ({
  type: WinnersActionTypes.FETCH_WINNERS_START,
  payload: searchQuery,
});

export const fetchWinnersSuccess = winners => ({
  type: WinnersActionTypes.FETCH_WINNERS_SUCCESS,
  payload: winners,
});

export const fetchWinnerGiftsStart = winnerId => ({
  type: WinnersActionTypes.FETCH_WINNER_GIFTS_START,
  payload: winnerId,
});

export const claimWinnerGiftStart = (rowIndex, isClaimed, winnerId) => ({
  type: WinnersActionTypes.CLAIM_WINNER_GIFT_START,
  payload: { rowIndex, isClaimed, winnerId },
});

export const nextPage = () => ({
  type: WinnersActionTypes.NEXT_PAGE,
});

export const prevPage = () => ({
  type: WinnersActionTypes.PREV_PAGE,
});

export const reloadPage = () => ({
  type: WinnersActionTypes.RELOAD_PAGE,
});

export const setWinnerState = state => ({
  type: WinnersActionTypes.SET_WINNER_STATE,
  payload: state,
});

export const searchCouponCode = code => ({
  type: WinnersActionTypes.SEARCH_COUPON_CODE,
  payload: code,
});

export const updateCouponCode = code => ({
  type: WinnersActionTypes.UPDATE_COUPON_CODE,
  payload: code,
});
